module.exports = __webpack_public_path__ + "img/icon-sb-credit-card-color-64x48.6e959e0.svg";